// window.addEventListener('load', () =>{

const mainProductSliders = document.querySelectorAll('.product__media-list') || []

mainProductSliders.forEach(mainProductSlider => {
  mainProductSlider.onscroll = () => {
    mainProductSlider.style.top = 0
  }
})

  
document.querySelectorAll('.js-desktop-burger').forEach(jsDesktopBurger => {
  jsDesktopBurger.onclick = () =>{
  document.querySelector('.menu').classList.toggle('active');
  refreshMenu()
 document.querySelector('body').classList.toggle('open-menu');
}})

// window.addEventListener('scroll',()=>{
//   document.querySelector('.menu').classList.remove('active');
//   refreshMenu()
// })

document.querySelector('.menu').onclick = (e) =>{
  if(e.target === e.currentTarget){
    document.querySelector('.menu').classList.remove('active');  
    refreshMenu()
    document.querySelector('body').classList.remove('open-menu');
  }
  
}


const menuListItems = document.querySelectorAll('.js-mobile-menu li[list-id]')
const menuLists = document.querySelectorAll('.js-mobile-menu ul[list-id]')
const otherLists = document.querySelectorAll('.js-mobile-menu-other')


menuListItems.forEach(menuListItem => {
  menuListItem.onclick = () =>{
    const wrap = menuListItem.closest('.js-mobile-menu')
    const attribute = menuListItem.getAttribute('list-id')
    if(wrap){
      wrap.classList.add('hide')
      console.log("attribute: ", attribute)
    }

    
    otherLists.forEach(otherList =>{
      otherList.classList.add('hide')
    })
    
    menuLists.forEach(menuList => {
      const inner_attribute = menuList.getAttribute('list-id')
      if(inner_attribute === attribute){
        console.log("menuList: ", menuList)
        menuList.classList.remove('hide')
        menuList.closest('.js-mobile-menu').classList.remove('hide')

        menuList.querySelector('button').onclick = () => {
          menuList.closest('.js-mobile-menu').classList.add('hide')
          menuList.classList.add('hide')
          wrap.classList.remove('hide')
          const main_ul = document.getElementById("stage-1")

          if(main_ul === wrap) {
            otherLists.forEach(otherList =>{
              otherList.classList.remove('hide')
            })
          }
          
        }
      }
    })
  }
})

function refreshMenu(){
  const menuListWrappers = document.querySelectorAll('.js-mobile-menu')
  menuListWrappers.forEach(menuListWrapper => {
    if(menuListWrapper.classList.contains('main_menu_stage')){
      menuListWrapper.classList.remove('hide')
    }else{
      menuListWrapper.classList.add('hide')
      const otherULs = menuListWrapper.querySelectorAll('ul')
      if(otherULs){
        otherULs.forEach(otherUL => {
          otherUL.classList.add('hide')
        })
      }
    }
  })
  otherLists.forEach(otherList =>{
    otherList.classList.remove('hide')
  })
}



const mainSwipers = document.querySelectorAll(".mySwiper")

mainSwipers.forEach(mainSwiper =>{
    var swiper = new Swiper(mainSwiper, {
        // slidesPerView: 1,
        // grid: {
        //     rows: 1,
        //     fill: "row"
        // },
        spaceBetween: 30,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
        },
        pagination: {
            el: '.product-pagination',
            type: "fraction"
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            350: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 3
            },
            1024: {
                slidesPerView: 4
            }
        }
    });
})

  new Swiper('.collage_slider', {
      speed: 400,
      spaceBetween: 32,
      navigation: {
          nextEl: ".swiper-btns .swiper-btn-next",
          prevEl: ".swiper-btns .swiper-btn-prev",
      },
      pagination: {
          el: '.swiper-pag',
          type: "fraction"
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
          // pagination: {
          //       el: '.swiper-pagination',
          //       // type: "fraction"
          //   },
        },
        340: {
          slidesPerView: 1.25,
          spaceBetween: 20
        },
        480: {
          slidesPerView: 1.75,
           spaceBetween: 20
        },
        
       768: {
           slidesPerView: 2.25,
           spaceBetween: 20,
           
        },
        900: {
          slidesPerView: 2.5,
          spaceBetween: 20
        },
         1000: {
          slidesPerView: 2.75,
           spaceBetween: 20
        },
        1100: {
          slidesPerView: 3,
         spaceBetween: 20
        },
        // when window width is >= 480px
        1200: {
          slidesPerView: 3.25,
          spaceBetween: 30
        },
        // when window width is >= 640px
        1300: {
          slidesPerView: 3.5,
          spaceBetween: 30,
        }
      }
    });




activateCardOptionMoreButton()

activateCardOptions()



const faqRows = document.querySelectorAll('.js-faq');

faqRows.forEach(item =>{
    const btns = item.querySelectorAll('.js-btn')
    const content = item.querySelector('.js-content')


    btns.forEach((btn,i,arr) =>{
        btn.onclick = () => {
            arr.forEach(item => {
              item.classList.toggle('active')
            })
            content.classList.toggle('active')
        }
    })

    // btn.
})

const urlParams = new URLSearchParams(window.location.search);
const currentPage = urlParams.get('page') || 1;

var swiper888 = new Swiper(".mySwiper", {
    initialSlide: currentPage - 1,
    slidesPerView: 1,
    grid: {
        rows: 1,
        fill: "row"

    },
    allowTouchMove: false,
    spaceBetween: 30,
    // pagination:true,
    pagination: {
        el: ".product-pagination",
        clickable: true,
        type: "fraction"
    },
    navigation: {
        nextEl: ".swiper-button-next-custom",
        prevEl: ".swiper-button-prev-custom",
    },
    breakpoints: {
            320: {
                slidesPerView: 1
            },
            350: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 3
            },
            1024: {
                slidesPerView: 4
            }
        }
    // pagination: {
    //     el: '.product-pagination',
    //     renderBullet: function (index, className) {
    //         return '<span class="custom-bullet ' + className + '">' + (index + 1) + "</span>";
    //     },
    // },
});

var swiper = new Swiper(".mySwiper10", {
    initialSlide: currentPage - 1,
    slidesPerView: 4,
    grid: {
        rows: 2,
        fill: "row"

    },
    allowTouchMove: false,
    spaceBetween: 30,
    // pagination:true,
    pagination: {
        el: ".product-pagination",
        clickable: true,
         type: "fraction"
    },
    navigation: {
        nextEl: ".swiper-button-next-custom",
        prevEl: ".swiper-button-prev-custom",
    },
    pagination: {
        el: '.product-pagination',
        renderBullet: function (index, className) {
            return '<span class="custom-bullet ' + className + '">' + (index + 1) + "</span>";
        },
    },
});

swiper.on('slideChange', function () {
    var currentSlideIndex = swiper.activeIndex;
    const urlParams = new URLSearchParams(window.location.search);
    const newUrl = window.location.pathname + '?page=' + (currentSlideIndex + 1);
    history.pushState({}, '', newUrl);
});


var swiper6 = new Swiper(".mySwiper6", {
    slidesPerView: 1,
    effect:'fade',
    allowTouchMove: false,
    fadeEffect: {
        crossFade: true,
    },
    speed: 100,

    
});

var swiper5 = new Swiper(".mySwiper5", {
    slidesPerView: 1,
    effect:'fade',
    fadeEffect: {
        crossFade: true,
    },
    speed: 100,
    navigation: true,
    pagination: {
        el: '.product-pagination-234',
        type: "fraction"
    },
    navigation: {
        nextEl: ".swiper-button-next-custom2",
        prevEl: ".swiper-button-prev-custom2",
    },
    thumbs: {
        swiper: swiper6,
    },
});

document.querySelectorAll('.js-filter-toggle').forEach(btn =>{
    btn.addEventListener("click", (e) =>{
        e.preventDefault()
        document.querySelector('.js-filter-container').classList.toggle("active");
        return false
    })
})

document.querySelectorAll('.js-filter-item').forEach(item =>{
    item.querySelector('.js-filter-item-btn').onclick = (e) =>{
      
        item.classList.toggle("active");
    }
})

const huge_menus = document.querySelectorAll('.huge_menu')


huge_menus.forEach(huge_menu => {

  const huge_menu_columns = huge_menu.querySelectorAll(".huge_menu_col")
  const huge_menu_first_menu_buttns = []

  huge_menu_columns.forEach((huge_menu_column,i) => {

    // if(i == 0){
      huge_menu_column.querySelectorAll(".huge_menu_list li").forEach((item, index, arr) =>{
        const listId =  item.getAttribute('list-id')

        item.onclick = () =>{
          const lists = huge_menu_columns[i + 1].querySelectorAll(".huge_menu_list") // to find lists in next column
          lists.forEach(_list=>{
            const _listId =  _list.getAttribute('list-id')
            if(listId === _listId){
              _list.style.display = 'inline-block'  
              huge_menu_columns[i + 1].style.opacity = '1'
              item.classList.add('active')
            }else{
              _list.style.display = 'none'  
              item.classList.remove('active')
              
            }
          })

          
          
          
          if(huge_menu_columns[1]){
          //   const _listId =  item.getAttribute('list-id')
          //   huge_menu_columns[1].style.opacity = "1"
          //   const lists = huge_menu_columns[1].querySelectorAll(".huge_menu_list")

          //   lists.forEach(list => {
          //     const __listID = list.getAttribute('list-id')
          //     if(listId === __listID){
          //       list.style.display = 'inline-block'  
          //     }else{
          //       list.style.display = 'none'  
          //     }
          //   })

            arr.forEach(_item =>{
              if(_item == item){
                _item.classList.add('active')
              }else{
                _item.classList.remove('active')    
              }
            })
            
            
          }
          if(huge_menu_columns[huge_menu_columns.length - 1]){
           huge_menu_columns[huge_menu_columns.length - 1].style.opacity = "1" 

            const lists = huge_menu_columns[huge_menu_columns.length - 1].querySelectorAll(".huge_menu_col__advertising_item")

            lists.forEach(list => {
              const __listID = list.getAttribute('list-id')
              if(listId === __listID){
                list.style.display = 'inline-block'  
              }else{
                list.style.display = 'none'  
              }
            })
          }            
        }
        
        
      })
    // }
    
    // if(i !== huge_menu_columns.length - 1){
    //   huge_menu_column.style.opacity = "0"
    // }

    // if(i == 1){
    //   const list = huge_menu_column.querySelectorAll(".huge_menu_list")
    //   list.forEach(inner_list =>{
    //     inner_list.style.display = 'none'  
    //   })
    // }
    if(i == huge_menu_columns.length - 1){
      const list = huge_menu_column.querySelectorAll(".huge_menu_col__advertising_item")
      huge_menu_column.style.opacity = '0'
      list.forEach(inner_list =>{
        inner_list.style.display = 'none'  
      })
    }
  })

  
  const listOuter = huge_menu.closest('.list_outer');


  const listItems_stage_1 =document.querySelectorAll('.header__nav_item > a.not-a-link');

  listItems_stage_1.forEach(listItem_stage_1 => {
    listItem_stage_1.onclick = () =>{
      listItem_stage_1.parentNode.classList.toggle('active')  
      // document.body.style.overflow = "hidden"
    }
    listItem_stage_1.ondblclick = () =>{
       // window.location.pathname = listItem_stage_1.getAttribute('customhref')

      const customHref = listItem_stage_1.getAttribute('customhref');
      const url = new URL(customHref, window.location.origin);
      
      // Set only the pathname (without query parameters)
      // window.location.pathname = url.pathname;
      window.location.href = url.pathname;

    }
    
    // listOuter.parentNode
      listItem_stage_1.parentNode.querySelector('.list_outer').onmouseout = (e) => {
      const flag = listItem_stage_1.parentNode.contains(e.relatedTarget || e.toElement);
      if(!flag){
         listItem_stage_1.parentNode.classList.remove('active') 
          // document.body.style.overflow = "unset"
      }
    }
  })
  
  
  if (listOuter) {
      listOuter.addEventListener('mouseout', (e) => {
       
          const flag = huge_menu.contains(e.relatedTarget || e.toElement);
  
          if (!flag) {
             
              huge_menu_columns.forEach((huge_menu_column, i) => {
                  if (i >= 1 ) {
                      huge_menu_column.style.opacity = "0";
                  }
  
                  if (i === 1) {
                      const list = huge_menu_column.querySelectorAll(".huge_menu_list");
                      list.forEach(inner_list => {
                          inner_list.style.display = 'none';
                      });
                  }

                   huge_menu_column.querySelectorAll('li').forEach(__item=>{
                    __item.classList.remove('active')
                  })
                 if(i == huge_menu_columns.length - 1){
                  const list = huge_menu_column.querySelectorAll(".huge_menu_col__advertising_item")
                  list.forEach(inner_list =>{
                    inner_list.style.display = 'none'  
                  })

                 
                }
              });

           
          }
        
      });
  }

})


activateBGColor()

function activateBGColor(colorFlag = false) {

 
  const jsColorBtns = document.querySelectorAll('label[js-color]')


  if(jsColorBtns){
    jsColorBtns.forEach((jsColorBtn,index)=>{
      const currentColor =  jsColorBtn.getAttribute('js-color')
      const currentIsActive =  jsColorBtn.getAttribute('js-is-active') || false
      const section = jsColorBtn.closest('section') || jsColorBtn.closest('.quick-add-modal__content-info') || null
      const attrFor = jsColorBtn.getAttribute('for')
      
      const input = document.querySelector(`input#${attrFor}`)
    
      
      if(currentIsActive){
        section.style.transition = 'background 0.2s ease-out'
        section.style.background= "rgba(var(--color-background))"
        section.style.background = currentColor
        section.style.backgroundSize = 'cover'
        section.style.backgroundRepeat = 'no-repeat'
        
      }
      
      input.addEventListener('change', () =>{
        
  
        // onchange = () =>{
        // console.log(index, currentColor, currentIsActive)
        if(section) {
          section.style.transition = 'background 0.2s ease-out'
          section.style.background= "rgba(var(--color-background))"
          section.style.background = currentColor
          section.style.backgroundSize = 'cover'
          section.style.backgroundRepeat = 'no-repeat'
        }
        
      // }
        })
    })
  }
  
}

// -----------



// })

function activateCardOptions() {
  // const options = document.querySelectorAll('.js-item-option') || []
  const cardsAAA = document.querySelectorAll('.js-product-card') || []
  
  cardsAAA.forEach((cardAAA,i) =>{
    let keyID = null
    // const parentNode = cardAAA.closest('.js-product-card')
    const top = cardAAA.querySelectorAll('.js-card-top-item')
    const bottom = cardAAA.querySelectorAll('.js-card-bottom-item')
    const options = cardAAA.querySelectorAll('.js-item-option')

   
    options.forEach((option,index) => {
      if(index == 0){
        keyID = option.getAttribute('keyID')  
      }
      
      option.onclick = (e) =>{
        findAndActive(top ,option.getAttribute('keyID')  )
        findAndActive(bottom,option.getAttribute('keyID')  )
        findAndActive(options, option.getAttribute('keyID')  )
      }  
    })
    if(keyID){
      
      if(options.length === 0){
        keyID = bottom[0].getAttribute('keyID') 
        findAndActive(top ,keyID)
        findAndActive(bottom,keyID)
        findAndActive(options,keyID)
      }else{
        findAndActive(top ,keyID)
        findAndActive(bottom,keyID)
        findAndActive(options,keyID)  
      }
    
    }

     console.log(keyID)
    
    
  
    // if(i === 0){
    //   findAndActive(top ,keyID)
    //   findAndActive(bottom,keyID)
    //   findAndActive(options,keyID)  
    // }
  
    function findAndActive(arr = [] , id){
        arr.forEach(item =>{
          const itemKeyID = item.getAttribute('keyID')
          if(itemKeyID == id){
            item.classList.add('active')
          }else{
            item.classList.remove('active')
          }
        })
    }
  })
    
}


// const observer = new IntersectionObserver((entries) => {


//   entries.forEach(entry => {
//     if (entry.isIntersecting) {
//       lazyLoadImage(entry)
//       observer.unobserve(entry.target)
//     }
//   })
// })

// observer

function activateCardOptionMoreButton(){

  // return
  const cardContentArr = document.querySelectorAll(':not(.hidden) .js-product-card')

  cardContentArr.forEach(cardContent => {
    const slider = cardContent.querySelector('.mySwiper2')

    const slider2 = cardContent.querySelector('.mySwiper3')


    var swiper2 = null;
    var swiper3 = null 
    if(slider){
        swiper2 = new Swiper(slider, {
            slidesPerView: 1,
            allowTouchMove: false
        });
    }
    if(slider2){
        swiper3 = new Swiper(slider2, {
            slidesPerView: 1,
            allowTouchMove: false,
            speed: 0,
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
        });
    }

    var optionButtons = cardContent.querySelectorAll('.product_collage__card_option');
    var optionButton = cardContent.querySelector('.product_collage__card_option');
    const gapWidth = 8

    if(!optionButton){
      return
    }
    let optionButtonWrap = optionButton ? optionButton.closest('.product_collage__card_options') : 0;
    let optionWidth = optionButton ? optionButton.getBoundingClientRect().width + gapWidth : 0
    let optionWrapWidth = optionButton ? optionButtonWrap.getBoundingClientRect().width + optionButton.getBoundingClientRect().width / 2.4  : 0

    let optionButtonCount = optionWrapWidth / optionWidth

    const div = document.createElement('a')
    div.classList.add('product_collage__card_option')
    div.classList.add('more')
    div.innerHTML = ((optionButtons.length + 1 - Math.floor(optionButtonCount)) <= 0 ? "" : '+' + (optionButtons.length - Math.floor(optionButtonCount) + 1) )
    div.style.position = 'absolute';
    div.style.right = '2px';
    div.style.top = '50%';
    div.style.borderColor = '#2C2C2C';
    div.style.fontSize = '12px';
    div.style.transform = 'translateY(-50%)';


    if(optionButtonWrap){
      optionButtonWrap.style.position ='relative'
      div.href = optionButtonWrap.getAttribute('href')
      optionButtonWrap.appendChild(div)
    }

    optionButtons.forEach(function (button, index) {

      
      if(index + 2 > optionButtonCount) {
        button.style.opacity = '0'
      }else{
        button.style.opacity = '1'
      }
      window.addEventListener('resize',()=>{
        // optionWidth = optionButton.getBoundingClientRect().width + gapWidth 
        // optionWrapWidth = optionButtonWrap.getBoundingClientRect().width + optionButton.getBoundingClientRect().width / 2.4
        // optionButtonCount = optionWrapWidth / optionWidth

        
        // if(index + 2 > optionButtonCount) {
        //   button.style.opacity = '0'
        // }else{
        //   button.style.opacity = '1'
        // }
        //  div.innerHTML = ((optionButtons.length + 1 - Math.floor(optionButtonCount)) <= 0 ? '' : '+' + (optionButtons.length - Math.floor(optionButtonCount) + 1) )
      })

      
      button.addEventListener('click', function (e) {
          if(swiper2){
              swiper2.slideTo(index);
          }
          if(swiper3){
              swiper3.slideTo(index);
          }

         
        
          
          const allRelatedBtns = e.currentTarget.parentNode.querySelectorAll('.product_collage__card_option:not(.more)')
          allRelatedBtns.forEach((item) => {
              if(item !== e.currentTarget){
                  item.classList.remove('active');
                  item.style.borderWidth = '0px'
              }else{
                  item.classList.add('active');
                  item.style.borderWidth = '2px'
              }
          })
      });
  });

})
}

function observerActivateCardOptionMoreButton(){

  // return
  const cardContentArr = document.querySelectorAll('.js-product-card')

  cardContentArr.forEach(cardContent => {
    // const slider = cardContent.querySelector('.mySwiper2')

    // const slider2 = cardContent.querySelector('.mySwiper3')


    // var swiper2 = null;
    // var swiper3 = null 
    // if(slider){
    //     swiper2 = new Swiper(slider, {
    //         slidesPerView: 1,
    //         allowTouchMove: false
    //     });
    // }
    // if(slider2){
    //     swiper3 = new Swiper(slider2, {
    //         slidesPerView: 1,
    //         allowTouchMove: false,
    //         speed: 0,
    //         effect: "fade",
    //         fadeEffect: {
    //             crossFade: true,
    //         },
    //     });
    // }

    var optionButtons = cardContent.querySelectorAll('.product_collage__card_option');
    var optionButton = cardContent.querySelector('.product_collage__card_option');
    const gapWidth = 8

    if(!optionButton){
      return
    }
    let optionButtonWrap = optionButton ? optionButton.closest('.product_collage__card_options') : 0;
    let optionWidth = optionButton ? optionButton.getBoundingClientRect().width + gapWidth : 0
    let optionWrapWidth = optionButton ? optionButtonWrap.getBoundingClientRect().width + optionButton.getBoundingClientRect().width / 2.4  : 0

    let optionButtonCount = optionWrapWidth / optionWidth

    const div = document.createElement('a')
    div.classList.add('product_collage__card_option')
    div.classList.add('more')
    div.innerHTML = ((optionButtons.length + 1 - Math.floor(optionButtonCount)) <= 0 ? "" : '+' + (optionButtons.length - Math.floor(optionButtonCount) + 1) )
    div.style.position = 'absolute';
    div.style.right = '2px';
    div.style.top = '50%';
    div.style.borderColor = '#2C2C2C';
    div.style.fontSize = '12px';
    div.style.transform = 'translateY(-50%)';


    if(optionButtonWrap){
      optionButtonWrap.style.position ='relative'
      div.href = optionButtonWrap.getAttribute('href')
      optionButtonWrap.appendChild(div)
    }

    optionButtons.forEach(function (button, index) {

      
      if(index + 2 > optionButtonCount) {
        button.style.opacity = '0'
      }else{
        button.style.opacity = '1'
      }
      window.addEventListener('resize',()=>{
        // optionWidth = optionButton.getBoundingClientRect().width + gapWidth 
        // optionWrapWidth = optionButtonWrap.getBoundingClientRect().width + optionButton.getBoundingClientRect().width / 2.4
        // optionButtonCount = optionWrapWidth / optionWidth

        
        // if(index + 2 > optionButtonCount) {
        //   button.style.opacity = '0'
        // }else{
        //   button.style.opacity = '1'
        // }
        //  div.innerHTML = ((optionButtons.length + 1 - Math.floor(optionButtonCount)) <= 0 ? '' : '+' + (optionButtons.length - Math.floor(optionButtonCount) + 1) )
      })

      
      button.addEventListener('click', function (e) {
          if(swiper2){
              swiper2.slideTo(index);
          }
          if(swiper3){
              swiper3.slideTo(index);
          }

         
        
          
          const allRelatedBtns = e.currentTarget.parentNode.querySelectorAll('.product_collage__card_option:not(.more)')
          allRelatedBtns.forEach((item) => {
              if(item !== e.currentTarget){
                  item.classList.remove('active');
                  item.style.borderWidth = '0px'
              }else{
                  item.classList.add('active');
                  item.style.borderWidth = '2px'
              }
          })
      });
  });

})
}